import { render, staticRenderFns } from "./CultivationAvatar.vue?vue&type=template&id=61bf6d06&scoped=true&lang=html&"
import script from "./CultivationAvatar.vue?vue&type=script&lang=js&"
export * from "./CultivationAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bf6d06",
  null
  
)

export default component.exports